import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-lfsa-combo-box-mult',
  templateUrl: './lfsa-combo-box-mult.component.html',
  styleUrls: ['./lfsa-combo-box-mult.component.css']
})
export class LfsaComboBoxMultComponent implements OnInit {

  @Output() enviarOjeto = new EventEmitter<any>();
  @Input() comboBox: any[];//data
  @Input() label: string;
  @Input() isReadOnly = false;//bloquear componente
  @Input() id: string;//id del componente

  @Input() opcion: string;//valor a mostrar en el combo
  @Input() idOpcion: string;//id de la llave de json
  
  @Input() habilitar: boolean;//bloquear componente
  // @Input() control: FormControl;
  @Input() claseLabel = '';//tipo de color del label
  @Input() multiple:boolean = true;
  @Input() placeholder: string = '';
  
  @Input() mostrarImg = false;
  @Input() rutaImagen: string = '';
  
  @Input() selectedItems = [];
  dropdownSettings = {};

  constructor() { }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: !this.multiple,
      idField: this.idOpcion,//'item_id',
      textField: this.opcion,//'item_text',
      selectAllText: 'Seleccionar Todo',
      unSelectAllText: 'Quitar Todo',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText	:'Buscar'
    };
  }

  onItemSelect(item: any) {
    console.log(item);
    this.enviarOjeto.emit(this.selectedItems);
  }

  onSelectAll(items: any) {
    console.log(items);
    this.selectedItems = items;
    this.enviarOjeto.emit(this.selectedItems);
  }

  onItemDeSelect(obj){
    console.log(obj);
    const posision = this.selectedItems.findIndex((e) => e[this.idOpcion] === obj[this.idOpcion]);
    if(this.selectedItems.length > 0){
      if(posision != -1){
        this.selectedItems.splice(posision, 1);
      }
    }
    console.log(this.selectedItems);
    this.enviarOjeto.emit(this.selectedItems);
  }

  onItemDeSelecAll(event){
    console.log(event);
    this.selectedItems = event;
    this.enviarOjeto.emit(this.selectedItems);
  }

}
